export default __webpack_public_path__ + "static/media/check.f6b1bd49.svg";